import 'css-chunksrc/client/pages/zonePage/projectsPage/loader/project/styles.scss';export default {
  "project": "_project_1boar_1"
};